import React from "react";
import { Chip, Box, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
export const TEMPERATURE_STATUS_COLORS = {
    normal: { bg: "#22C55E29", text: "#118D57" },
    high: { bg: "#FFCDD2", text: "#B71C1C" },
    low: { bg: "#FF563029", text: "#B71D18" },
    inactive: { bg: "#E2E8F0", text: "#64748B" },
};
/**
 * Derives temperature status from node row data for badge and icon color.
 * Inactive = not active or no temperature. Otherwise: below low → low, above high → high, else normal.
 */
export function getNodeTemperatureStatus(row) {
    const { nodeTemperature, lowTemperature, highTemperature, isActive } = row;
    if (!isActive || nodeTemperature == null)
        return "inactive";
    const low = lowTemperature != null ? Number(lowTemperature) : null;
    const high = highTemperature != null ? Number(highTemperature) : null;
    const temp = Number(nodeTemperature);
    if (low != null && temp < low)
        return "low";
    if (high != null && temp > high)
        return "high";
    return "normal";
}
/**
 * Returns the circle color for TemperatureDisplay based on status.
 */
export function getNodeTemperatureColor(row) {
    const status = getNodeTemperatureStatus(row);
    const colorMap = {
        normal: "#1D95E2",
        high: "#FF5630",
        low: "#FF5630",
        inactive: "#919EAB",
    };
    return colorMap[status];
}
export const TemperatureStatusBadge = ({ status, label, }) => {
    const { t } = useTranslation("common");
    const colors = TEMPERATURE_STATUS_COLORS[status];
    const displayLabel = label !== null && label !== void 0 ? label : (status === "inactive"
        ? "–"
        : t(`common:labels.temperature${status.charAt(0).toUpperCase()}${status.slice(1)}`));
    return (React.createElement(Box, { sx: { display: "inline-flex" } },
        React.createElement(Chip, { label: displayLabel, size: "small", sx: {
                backgroundColor: colors.bg,
                color: colors.text,
                fontWeight: 600,
                "& .MuiChip-label": { px: 1 },
                "&:hover": {
                    backgroundColor: alpha(colors.text, 0.15),
                    color: colors.text,
                },
            } })));
};
export default TemperatureStatusBadge;
